<template>
  <div v-if="data"
       class="relative py-[5px] pl-[5px] pr-[15px] bg-zt-light-transparent w-full h-[75px] flex flex-nowrap items-center
              rounded-zt border border-zt-light group no-default-style zt-hover cursor-pointer xl:h-fit xl:py-2
              xl:pl-5 xl:pr-[30px]"
       :class="[{ 'pointer-events-none': postLink.length === 0 }, { 'single-gala': !isFeatured },
                { 'xl:pl-[5px]': isInSidebar && !DefaultImagesSize }, 'border-zt-light']"
       :data-href="postLink"
       :data-count-click="countAnalytic"
       data-count-click-category="martial_fights"
       style="box-shadow: 0 16px 6px rgba(0, 0, 0, 0.01), 0 9px 5px rgba(0, 0, 0, 0.05), 0 4px 4px rgba(0, 0, 0, 0.09), 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 rgba(0, 0, 0, 0.1)">
    <svg v-if="isFeatured && isInSidebar && WP.id !== 58061" class="absolute top-0 shrink-0 w-[17px] left-[16px]" viewBox="4 0 34 49"
      fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_8103_9647)">
        <path d="M4 -1H38V40L21 26L4 40V-1Z" fill="#FF4A5D" />
      </g>
      <path
        d="M26.6723 13.2C26.4423 12.9 26.1623 12.64 25.9023 12.38C25.2323 11.78 24.4723 11.35 23.8323 10.72C22.3423 9.26 22.0123 6.85 22.9623 5C22.0123 5.23 21.1823 5.75 20.4723 6.32C17.8823 8.4 16.8623 12.07 18.0823 15.22C18.1223 15.32 18.1623 15.42 18.1623 15.55C18.1623 15.77 18.0123 15.97 17.8123 16.05C17.5823 16.15 17.3423 16.09 17.1523 15.93C17.0952 15.8828 17.0476 15.8251 17.0123 15.76C15.8823 14.33 15.7023 12.28 16.4623 10.64C14.7923 12 13.8823 14.3 14.0123 16.47C14.0723 16.97 14.1323 17.47 14.3023 17.97C14.4423 18.57 14.7123 19.17 15.0123 19.7C16.0923 21.43 17.9623 22.67 19.9723 22.92C22.1123 23.19 24.4023 22.8 26.0423 21.32C27.8723 19.66 28.5123 17 27.5723 14.72L27.4423 14.46C27.2323 14 26.6723 13.2 26.6723 13.2ZM23.5123 19.5C23.2323 19.74 22.7723 20 22.4123 20.1C21.2923 20.5 20.1723 19.94 19.5123 19.28C20.7023 19 21.4123 18.12 21.6223 17.23C21.7923 16.43 21.4723 15.77 21.3423 15C21.2223 14.26 21.2423 13.63 21.5123 12.94C21.7023 13.32 21.9023 13.7 22.1423 14C22.9123 15 24.1223 15.44 24.3823 16.8C24.4223 16.94 24.4423 17.08 24.4423 17.23C24.4723 18.05 24.1123 18.95 23.5123 19.5Z"
        fill="white" />
      <defs>
        <filter id="filter0_d_8103_9647" x="0" y="-1" width="42" height="49" filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8103_9647" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8103_9647" result="shape" />
        </filter>
      </defs>
    </svg>
    <img v-if="thumbnailSmallMobile && thumbnailMedium && thumbnailSmallMobile.length > 0 && thumbnailMedium.length > 0"
         class="w-[89px] h-[55px] rounded-zt shrink-0 object-cover"
         :class="!((isInSidebar && WP.id !== 58061) || window.size.mobile) || DefaultImagesSize ? 'xl:w-[151px] xl:h-[85px]' : ''"
         alt="" width="89" height="55"
         :src="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'"
         :data-srcset="`${thumbnailSmallMobile} 89w, ${thumbnailMedium} 3000w`" sizes="(max-width: 1280px) 89px, 100vw">
    <div v-else class="w-[89px] h-[55px] rounded-zt bg-black items-center justify-center shrink-0 flex"
      :class="!((isInSidebar && WP.id !== 58061) || window.size.mobile) || DefaultImagesSize ? 'xl:w-[151px] xl:h-[85px]' : ''">
      <img class="w-[80%] h-[80%] object-contain" @error="setDefaultImage"
        :src="'/wp-content/themes/zawodtyper/assets/images/gale_logo/' + federationName.toLowerCase().replaceAll(/[ _\-]/g, '') + '.webp'"
        alt="" width="89" height="55">
    </div>
    <div class="flex flex-col ml-3 gap-y-1 shrink basis-[calc(100%_-_102px)] min-w-0 pr-2"
         :class="!((isInSidebar && WP.id !== 58061) || window.size.mobile) || DefaultImagesSize ? 'xl:gap-y-4 xl:ml-[30px]' : ''">
      <div class="items-center">
        <div class="font-semibold pr-2 text-sm flex items-center"
             :class="!((isInSidebar && WP.id !== 58061) || window.size.mobile) || DefaultImagesSize ? 'xl:text-[24px] xl:leading-8' : ''">
          <span v-if="type === 'Gala'" class="gala-name line-clamp-2">
            {{ name }}
            <svg v-if="WP.id === 58061 && highlighted" class="inline-flex ml-1.5 mb-[2px] w-3.5 h-3.5 xl:mb-[3px] xl:w-5 xl:h-5"
                 xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none">
              <path d="M9.85664 0.980064C10.0591 0.356825 10.9409 0.356824 11.1434 0.980064L12.93 6.47887C13.0206 6.7576 13.2803 6.9463 13.5734 6.9463H19.3552C20.0105 6.9463 20.283 7.78487 19.7528 8.17005L15.0752 11.5685C14.8381 11.7408 14.7389 12.0461 14.8295 12.3248L16.6162 17.8236C16.8187 18.4469 16.1053 18.9651 15.5752 18.5799L10.8976 15.1815C10.6605 15.0092 10.3395 15.0092 10.1024 15.1815L5.42481 18.5799C4.89465 18.9651 4.18133 18.4469 4.38383 17.8236L6.1705 12.3248C6.26107 12.0461 6.16186 11.7408 5.92476 11.5685L1.24719 8.17005C0.717034 7.78487 0.989499 6.9463 1.64481 6.9463H7.4266C7.71967 6.9463 7.9794 6.7576 8.06997 6.47887L9.85664 0.980064Z" fill="#FAFF00"/>
            </svg>
          </span>
          <span v-else class="gala-name line-clamp-2">{{ type + ' ' + name }}
            <svg v-if="WP.id === 58061 && highlighted"
                 class="inline-flex ml-1.5 mb-[2px] w-3.5 h-3.5 xl:mb-[3px] xl:w-5 xl:h-5"
                 xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none">
              <path d="M9.85664 0.980064C10.0591 0.356825 10.9409 0.356824 11.1434 0.980064L12.93 6.47887C13.0206 6.7576 13.2803 6.9463 13.5734 6.9463H19.3552C20.0105 6.9463 20.283 7.78487 19.7528 8.17005L15.0752 11.5685C14.8381 11.7408 14.7389 12.0461 14.8295 12.3248L16.6162 17.8236C16.8187 18.4469 16.1053 18.9651 15.5752 18.5799L10.8976 15.1815C10.6605 15.0092 10.3395 15.0092 10.1024 15.1815L5.42481 18.5799C4.89465 18.9651 4.18133 18.4469 4.38383 17.8236L6.1705 12.3248C6.26107 12.0461 6.16186 11.7408 5.92476 11.5685L1.24719 8.17005C0.717034 7.78487 0.989499 6.9463 1.64481 6.9463H7.4266C7.71967 6.9463 7.9794 6.7576 8.06997 6.47887L9.85664 0.980064Z" fill="#FAFF00"/>
            </svg>
          </span>
        </div>
      </div>
      <div class="flex space-x-2 text-[#93A3BA] text-xs shrink"
           :class="!((isInSidebar && WP.id !== 58061) || window.size.mobile) || DefaultImagesSize ? 'xl:text-[16px] xl:space-x-5' : ''">
        <div class="flex flex-nowrap items-center gap-x-1 shrink-0">
          <svg class="w-[15px] h-[15px]" width="15" height="15" viewBox="0 0 15 15" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect x="1.50781" y="2.00195" width="12" height="12" rx="2" stroke="#93A3BA" stroke-width="0.7" />
            <path d="M1.60938 5.45625H13.6094" stroke="#93A3BA" stroke-width="0.7" stroke-linejoin="round" />
            <path d="M10.6068 1.09088L10.6068 3.10475" stroke="#93A3BA" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M4.61458 1.09088L4.61458 3.10475" stroke="#93A3BA" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M3.94531 8.13762H4.61198" stroke="#93A3BA" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M7.27344 8.13744H7.9401" stroke="#93A3BA" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M10.6094 8.13762H11.276" stroke="#93A3BA" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M3.94531 10.8232H4.61198" stroke="#93A3BA" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M7.27344 10.823H7.9401" stroke="#93A3BA" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M10.6094 10.8232H11.276" stroke="#93A3BA" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <div v-if="status === 'IP'" class="font-medium text-sm flex flex-nowrap items-center justify-center">
            <span class="text-zt-red gala-date">TRWA</span>
            <svg class="ml-2" width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.93429 1.0822C4.19273 1.34806 4.19273 1.77909 3.93429 2.04494C1.00536 5.05794 1.00536 9.94299 3.93429 12.9559C4.19273 13.2218 4.19273 13.6529 3.93429 13.9187C3.67586 14.1846 3.25685 14.1846 2.99841 13.9187C-0.447388 10.374 -0.447388 4.62691 2.99841 1.0822C3.25685 0.81635 3.67586 0.81635 3.93429 1.0822ZM15.4768 1.0822C18.9226 4.62691 18.9226 10.374 15.4768 13.9187C15.2184 14.1846 14.7993 14.1846 14.5409 13.9187C14.2824 13.6529 14.2824 13.2218 14.5409 12.9559C17.4699 9.94299 17.4699 5.05794 14.5409 2.04494C14.2824 1.77909 14.2824 1.34806 14.5409 1.0822C14.7993 0.81635 15.2184 0.81635 15.4768 1.0822ZM6.42996 3.6495C6.6884 3.91535 6.6884 4.34639 6.42996 4.61224C4.87935 6.20736 4.87935 8.79351 6.42996 10.3887C6.6884 10.6545 6.6884 11.0856 6.42996 11.3514C6.17153 11.6173 5.75252 11.6173 5.49409 11.3514C3.4266 9.22457 3.4266 5.7763 5.49409 3.6495C5.75252 3.38365 6.17153 3.38365 6.42996 3.6495ZM12.9811 3.6495C15.0486 5.7763 15.0486 9.22457 12.9811 11.3514C12.7226 11.6173 12.3037 11.6173 12.0452 11.3514C11.7868 11.0856 11.7868 10.6545 12.0452 10.3887C13.5958 8.79351 13.5958 6.20736 12.0452 4.61224C11.7868 4.34639 11.7868 3.91535 12.0452 3.6495C12.3037 3.38365 12.7226 3.38365 12.9811 3.6495ZM9.23759 6.13892C9.96853 6.13892 10.5611 6.74851 10.5611 7.50043C10.5611 8.25235 9.96853 8.86195 9.23759 8.86195C8.50665 8.86195 7.91406 8.25235 7.91406 7.50043C7.91406 6.74851 8.50665 6.13892 9.23759 6.13892Z"
                fill="#FF4A5D" />
            </svg>
          </div>
          <span v-else class="gala-date">{{ formatedGalaDate }}</span>
        </div>
        <div v-if="isRelationPlanned === '1' && (type === 'Gala' || DefaultImagesSize)"
          class="flex items-center px-1.5 border-[1px] border-zt-light !text-[10px] rounded-[15px] shrink-0 bg-zt-main/10"
          :class="window.size.mobile ? '' : 'xl:text-sm xl:px-3'">
          <span class="gala-relation">Relacja</span>
        </div>
        <div v-if="isRelationPlanned === '0' && (type === 'Gala' || DefaultImagesSize)"
             class="flex items-center px-1.5 border-[1px] border-zt-light !text-[10px] rounded-[15px] shrink-0
                    opacity-60 bg-zt-main/10"
             :class="window.size.mobile ? '' : 'xl:text-sm xl:px-3'">
          <span class="gala-relation">Bez relacji</span>
        </div>
        <div v-if="type !== 'Gala'"
             class="flex items-center bg-[#6068B51A] px-1.5 border-[1px] border-zt-light !text-[10px] rounded-[15px]
                    shrink grow max-w-fit min-w-0 truncate"
             :class="window.size.mobile || isInSidebar ? '' : 'xl:bg-zt-main/10 xl:!text-sm xl:px-3'">
          <span class="gala-relation">{{ type }}</span>
        </div>
        <div v-if="((window.size.mobile || (isInSidebar && WP.id !== 58061)) && type === 'Gala'
                    && linkText !== 'Relacja' && WP.id !== 58061 && postLink.length > 0
                    && (!window.size.mobile && DefaultImagesSize)) && !isRelationPage"
             class="flex items-center bg-[#6068B51A] px-1.5 border-[1px] border-zt-light text-[10px] rounded-[15px]
                    shrink grow max-w-fit min-w-0 truncate">
          <span class="gala-fight-card">{{ linkText }}</span>
        </div>
      </div>
    </div>
    <div v-if="window.size.desktop && !isInSidebar"
      class="whitespace-nowrap ml-auto flex items-center gap-2 group-hover:translate-x-0.5"
      :class="{ 'opacity-20': postLink.length <= 0 }">
      <span class="gala-fight-card text-zt-more font-medium">{{ linkText }}</span>
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.3437 13.6261L15.9955 6.99858L10.3437 0.371094L9.42061 1.45352L13.5178 6.23898L3.23438 6.23898L3.23438 7.75817L13.5178 7.75817L9.42061 12.5436L10.3437 13.6261Z"
          fill="#93A3BA" />
        <path d="M1.29555 6.23828H0L0 7.75748H1.29555L1.29555 6.23828Z" fill="#93A3BA" />
      </svg>
    </div>
    <svg v-if="window.size.mobile || isInSidebar || isRelationPage" class="ml-auto shrink-0 group-hover:translate-x-0.5"
      :class="[{ 'opacity-40': postLink.length <= 0 }, window.size.mobile || isInSidebar ? '' : 'xl:mr-8']" width="18"
      height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M0.728153 0.773909C0.797822 0.708017 0.880585 0.65574 0.971703 0.62007C1.06282 0.584401 1.1605 0.56604 1.25915 0.56604C1.3578 0.56604 1.45549 0.584401 1.5466 0.62007C1.63772 0.65574 1.72048 0.708017 1.79015 0.773909L10.7902 9.26447C10.86 9.3302 10.9154 9.40828 10.9532 9.49424C10.991 9.5802 11.0105 9.67235 11.0105 9.76542C11.0105 9.85849 10.991 9.95064 10.9532 10.0366C10.9154 10.1226 10.86 10.2006 10.7902 10.2664L1.79015 18.7569C1.64932 18.8898 1.45832 18.9644 1.25915 18.9644C1.05999 18.9644 0.868983 18.8898 0.728153 18.7569C0.587323 18.6241 0.508206 18.4439 0.508206 18.256C0.508206 18.0681 0.587323 17.8879 0.728153 17.755L9.19865 9.76542L0.728153 1.7758C0.658308 1.71007 0.602894 1.63199 0.565084 1.54603C0.527275 1.46007 0.507812 1.36792 0.507812 1.27485C0.507812 1.18179 0.527275 1.08963 0.565084 1.00367C0.602894 0.917712 0.658308 0.839634 0.728153 0.773909Z"
        fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M6.72815 0.773909C6.79782 0.708017 6.88058 0.65574 6.9717 0.62007C7.06282 0.584401 7.1605 0.56604 7.25915 0.56604C7.3578 0.56604 7.45549 0.584401 7.5466 0.62007C7.63772 0.65574 7.72048 0.708017 7.79015 0.773909L16.7902 9.26447C16.86 9.3302 16.9154 9.40828 16.9532 9.49424C16.991 9.5802 17.0105 9.67235 17.0105 9.76542C17.0105 9.85849 16.991 9.95064 16.9532 10.0366C16.9154 10.1226 16.86 10.2006 16.7902 10.2664L7.79015 18.7569C7.64932 18.8898 7.45832 18.9644 7.25915 18.9644C7.05999 18.9644 6.86898 18.8898 6.72815 18.7569C6.58732 18.6241 6.50821 18.4439 6.50821 18.256C6.50821 18.0681 6.58732 17.8879 6.72815 17.755L15.1987 9.76542L6.72815 1.7758C6.65831 1.71007 6.60289 1.63199 6.56508 1.54603C6.52727 1.46007 6.50781 1.36792 6.50781 1.27485C6.50781 1.18179 6.52727 1.08963 6.56508 1.00367C6.60289 0.917712 6.65831 0.839634 6.72815 0.773909Z"
        fill="white" />
    </svg>
    <a v-if="type === 'Gala'" :data-count-click="countAnalytic" data-count-click-category="martial_fights"
       :href="postLink" class="no-default-style absolute top-0 left-0 w-full h-full opacity-0">
      {{ name }}
    </a>
  </div>
</template>

<script>
import utils_mixin from "../mixins/utils_mixin";

export default {
  name: 'GalaItem',
  props: {
    data: Object,
    isFeaturedGala: Boolean,
    isInSidebar: Boolean,
    galaHour: String,
    DefaultImagesSize: {
      default: false,
      type: Boolean
    },
   isRelationPage: {
     default: false,
     type: Boolean
   },
	  galaStatus: {
			type: String
	  }
  },
  inject: ['WP'],
	mixins: [utils_mixin],
  computed: {
    countAnalytic() {
      if (this.isRelationPage) {
        return 'RELACJA ➝ INNE GALE: Kliki w gale';
      }
      if (window.location.pathname !== '/sporty-walk/') {
        return '';
      }
      let name = '';
      if (this.galaStatus === 'Nadchodzace') {
        name = 'Nadchodzące';
      }
      if (this.galaStatus === 'Przeszle') {
        name = 'Ostatnie wyniki';
      }
      return name;
    },
    postLink() {
      return this.data.post_link;
    },
    isRelationPlanned() {
      return this.data.is_relation_planned;
    },
    formatedGalaDate() {
      return this.data.formatedGalaDate;
    },
    name() {
      return this.data.name;
    },
    federationName() {
      return this.data.federation_name;
    },
    thumbnailSmall() {
      return this.data.thumbnail_small;
    },
    thumbnailSmallMobile() {
      return this.data.thumbnail_small_mobile;
    },
    thumbnailMedium() {
      return this.data.thumbnail_medium;
    },
    linkText() {
      return this.data.bottom_link;
    },
    isFeatured() {
      return this.isFeaturedGala;
    },
    status() {
      return this.data.status;
    },
    type() {
      return this.data.type;
    },
    highlighted() {
      return Number(this.data.highlight_gala) ?? 0;
    }
  },
  mounted() {
    this.$nextTick(() => {
      lazyLoad();
      setTimeout(() => {
        initializeClickableElements();
      }, 100);
    });
  },
  methods: {
    setDefaultImage(event) {
      event.target.src = '/wp-content/themes/zawodtyper/assets/images/gale_logo/sporty_walk.webp';
    }
  }
}
</script>